// Centralised deploy-target flag.
//
// The same codebase serves two surfaces:
//   - app.studyradar.ai  -> full product
//   - lti.studyradar.ai  -> standalone OSCE simulator
//
// The target is resolved at runtime so a SINGLE Vercel project can serve both
// domains (one build, two domains). Resolution order:
//   1. REACT_APP_DEPLOY_TARGET env var, if set (wins — used for local dev and
//      previews, e.g. `REACT_APP_DEPLOY_TARGET=lti npm start`).
//   2. Otherwise, the request hostname (lti.* -> standalone simulator).
//
// Import IS_LTI_APP anywhere a feature needs to behave differently on the
// standalone simulator domain. Import SIM_BASE for the route prefix: it is
// "/sim" on the lti domain and "/osce" on the full product, so the same shared
// components route correctly on both surfaces. Keep the checks here so there's
// a single source of truth.

const ENV_TARGET = String(process.env.REACT_APP_DEPLOY_TARGET ?? "")
  .trim()
  .toLowerCase();

// On the deployed site, decide by hostname so one project can host both domains.
function detectFromHost() {
  if (typeof window === "undefined") return "";
  const host = window.location.hostname.toLowerCase();
  return host === "lti.studyradar.ai" || host.startsWith("lti.") ? "lti" : "";
}

export const DEPLOY_TARGET = ENV_TARGET || detectFromHost();

export const IS_LTI_APP = DEPLOY_TARGET === "lti";

// Route prefix for the OSCE simulator surface. "/sim" on the standalone lti
// domain, "/osce" on the full product — shared components build their router
// paths from this so they stay correct on whichever surface they render.
export const SIM_BASE = IS_LTI_APP ? "/sim" : "/osce";
